jQuery(document).ready(function($){
  function testimonials_slider() {
    $('.about-testimonial').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 4000,
    });
  }
  testimonials_slider();
  document.addEventListener("shopify:section:load", testimonials_slider);
});

setTimeout(function() { 
  $(document).on('click', '.swatch-element-color', function() {
      const selectedColor = $(this).data('value'); 
      const $productMeta = $('.product-single__meta'); 
  
      $productMeta.removeClass(function(index, className) {
          return (className.match(/(^|\s)\S+/g) || []).filter(className => className !== 'product-single__meta').join(' ');
      });
  
      $productMeta.addClass(selectedColor.toLowerCase());
  });
 }, 1000);